export default {
  ready: 'ready',
  playing: 'playing',
  finished: 'finished',
}
